// extracted by mini-css-extract-plugin
export default {"container":"fH-z","innerContainer":"gH-z","multipleLines":"hH-z","heading":"iH-z","content":"jH-z","linkColor":"kH-z"};